/* MOB-23 shopping-flow script, moved out of snippets/mob23-flow.liquid
   (CRO-22, 28 Oct 2026) so it is cached instead of inline on every page.
   Unchanged apart from PDP_ML, which now comes from window.M23_ML (set
   inline by the snippet). */
(function(){
  if (window.__mob23) return;
  window.__mob23 = true;
  var html = document.documentElement;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_DELIVERY = ROOT + 'cart#delivery';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }); } catch (e) { fmt = null; }
  function money(c){ var n = (c || 0) / 100; return fmt ? fmt.format(n) : '£' + n.toFixed(2); }
  function phone(){ return !(window.matchMedia && window.matchMedia('(min-width: 750px)').matches); }
  function getCart(){
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); });
  }

  /* ================= 1. floating buttons guard =================
     MOB-23 round 2 (23 OCT 2026, Mitch): one rule on every page, phone and
     desktop, popups and drawers included. The Smile.io carrot coins launcher
     and the Tidio chat bubble each fade out while anything you can tap
     (button, link, field, label, radio, tab...) is underneath them, and come
     back as soon as the spot is clear. It looks at what is actually on top at
     each point under the float, so a control hidden behind an open drawer or
     popup does not count, and a control inside one does. An open Tidio chat
     is never hidden. On phones they also stay out of the way while the cart
     drawer or the build-your-box sheet is open. Replaces the PDP-23 buy-row
     rule, which this covers. */
  var COINS = '#smile-ui-lite-launcher-frame-container, #smile-ui-launcher-frame-container, .smile-launcher-frame-container, [id^="smile-"][id*="launcher"]';
  var FLOAT_ROOTS = '#smile-ui-lite-container, #smile-ui-container, [id^="smile-ui"], [id^="smile-"][id*="launcher"], .smile-launcher-frame-container, #tidio-chat';
  var TAPPABLE = 'button, a[href], input:not([type="hidden"]), label, select, textarea, summary, [role="button"], [role="radio"], [role="checkbox"], [role="link"], [role="tab"], [role="option"], [contenteditable="true"]';
  function boxOf(sel){
    var out = [];
    [].slice.call(document.querySelectorAll(sel)).forEach(function(c){
      [c].concat([].slice.call(c.querySelectorAll('iframe, div, button'))).forEach(function(e){
        if (getComputedStyle(e).display === 'none') return;
        var r = e.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) out.push(r);
      });
    });
    return out;
  }
  /* the visible launcher, as one rectangle (its smallest box: the button
     itself rather than a wider transparent frame around it) */
  function launcherRect(sel){
    var rs = boxOf(sel), best = null;
    rs.forEach(function(r){
      if (r.width > window.innerWidth * 0.9 && r.height > window.innerHeight * 0.5) return;
      if (!best || (r.width * r.height) < (best.width * best.height)) best = r;
    });
    return best;
  }
  function isFloat(el){ return !!(el && el.closest && el.closest(FLOAT_ROOTS)); }
  function coversControl(r){
    if (!r || typeof document.elementsFromPoint !== 'function') return false;
    var pad = 6, W = window.innerWidth, H = window.innerHeight;
    var xs = [r.left - pad, r.left + r.width * 0.25, r.left + r.width * 0.5, r.left + r.width * 0.75, r.right + pad];
    var ys = [r.top - pad, r.top + r.height * 0.25, r.top + r.height * 0.5, r.top + r.height * 0.75, r.bottom + pad];
    for (var i = 0; i < xs.length; i++){
      for (var j = 0; j < ys.length; j++){
        var x = Math.round(xs[i]), y = Math.round(ys[j]);
        if (x < 0 || y < 0 || x >= W || y >= H) continue;
        var stack;
        try { stack = document.elementsFromPoint(x, y); } catch (e) { continue; }
        for (var k = 0; k < stack.length; k++){
          var el = stack[k];
          if (isFloat(el)) continue;
          if (el === document.documentElement || el === document.body) break;
          if (el.closest && el.closest(TAPPABLE)) return true;
          break;   /* only what is actually on top counts */
        }
      }
    }
    return false;
  }
  function boxRoots(){
    return [].slice.call(document.querySelectorAll('[id^="pbx-"]')).filter(function(el){
      return !!el.querySelector('[data-dock], [data-panel]');
    });
  }
  /* phones: whole states where the floats stay away (round 1) */
  function screenState(){
    if (!phone()) return false;
    if (document.body && /(^|\s)template-cart(\s|$)/.test(document.body.className)) return true;
    if (document.querySelector('.pcart.is-open')) return true;
    var boxes = boxRoots();
    for (var i = 0; i < boxes.length; i++){
      if (/(^|\s)is-(sheet|psheet|fsheet)(\s|$)/.test(boxes[i].className)) return true;
    }
    return false;
  }
  var raf = 0;
  /* TIDIO-23 (23 OCT 2026, Mitch 18:28): the real Tidio widget. Its iframe
     (#tidio-chat-iframe) can be larger than the round bubble it shows, so
     the bubble is taken as the bottom right 80x80 of the iframe (the last
     place it was seen is kept while it is hidden). Tidio's own API hides and
     shows it (tidioChatApi.hide/show, open state from its open/close
     events); the pc-hide-tidio CSS does the same if the API is not there.
     It is never hidden while the chat window is open. */
  var KEYS = '.pbx__dock, .mob23-go, .mob23-sheetbar, .mob23-cartbar, .pcart__foot, .pcart__checkout, .pcart-checkout, [name="checkout"], [name="add"], .pg-atc, .pr-pdp__add, button[type="submit"]';
  var tidio = { api: null, open: false, hiddenByUs: false, last: null };
  function bindTidio(){
    var a = window.tidioChatApi;
    if (tidio.api || !a || typeof a.hide !== 'function' || typeof a.show !== 'function') return;
    tidio.api = a;
    try {
      if (typeof a.on === 'function') {
        a.on('open', function(){ tidio.open = true; html.classList.add('pc-tidio-open'); if (tidio.hiddenByUs) { tidio.hiddenByUs = false; try { a.show(); } catch (e) {} } setTidio(false); });
        a.on('close', function(){ tidio.open = false; html.classList.remove('pc-tidio-open'); queue(); });
      }
    } catch (e) {}
    queue();
  }
  document.addEventListener('tidioChat-ready', bindTidio);
  function tidioBubble(){
    var f = document.getElementById('tidio-chat-iframe');
    var r = f ? f.getBoundingClientRect() : null;
    if (!r || r.width < 10 || r.height < 10 || (f && getComputedStyle(f).display === 'none')) return tidio.last;
    var w = Math.min(r.width, 80), h = Math.min(r.height, 80);
    tidio.last = { left: r.right - w, top: r.bottom - h, right: r.right, bottom: r.bottom, width: w, height: h };
    return tidio.last;
  }
  function tidioOpen(){
    if (tidio.api) return tidio.open;
    var f = document.getElementById('tidio-chat-iframe');
    if (!f) return false;
    var r = f.getBoundingClientRect();
    return r.height > 260 && r.width > 300;
  }
  /* a buy / checkout control (visible) overlapping the area */
  function overlapsKey(b){
    if (!b) return false;
    var pad = 6, els = document.querySelectorAll(KEYS);
    for (var i = 0; i < els.length; i++){
      var e = els[i];
      if (e.closest && e.closest(FLOAT_ROOTS)) continue;
      var r = e.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) continue;
      if (r.right < b.left - pad || r.left > b.right + pad || r.bottom < b.top - pad || r.top > b.bottom + pad) continue;
      var cs = getComputedStyle(e);
      if (cs.visibility === 'hidden' || +cs.opacity === 0) continue;
      if (typeof e.checkVisibility === 'function' && !e.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) continue;
      return true;
    }
    return false;
  }
  function setTidio(h){
    if (h !== html.classList.contains('fg-hide-chat')) html.classList.toggle('fg-hide-chat', h);
    if (h !== html.classList.contains('pc-hide-tidio')) html.classList.toggle('pc-hide-tidio', h);
    var a = tidio.api;
    if (!a) return;
    try {
      if (h && !tidio.hiddenByUs) { tidio.hiddenByUs = true; a.hide(); }
      else if (!h && tidio.hiddenByUs) { tidio.hiddenByUs = false; a.show(); }
    } catch (e) {}
  }
  function check(){
    raf = 0;
    bindTidio();
    var chatOpen = tidioOpen();
    var state = screenState();
    var c = state || coversControl(launcherRect(COINS));
    var tb = tidioBubble();
    var h = !chatOpen && !!(state || coversControl(tb) || overlapsKey(tb));
    if (c !== html.classList.contains('fg-hide-coins')) html.classList.toggle('fg-hide-coins', c);
    setTidio(h);
  }
  function queue(){ if (!raf) raf = requestAnimationFrame(check); }
  window.__floatGuardCheck = queue;
  window.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('resize', queue);
  document.addEventListener('click', function(){ setTimeout(queue, 60); setTimeout(queue, 400); }, true);
  document.addEventListener('transitionend', queue, true);
  html.addEventListener('theme:cartchanged', function(){ setTimeout(queue, 400); });
  function startGuard(){
    if (window.MutationObserver) {
      var mt = 0;
      new MutationObserver(function(){ clearTimeout(mt); mt = setTimeout(queue, 120); })
        .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'style'] });
    }
    setInterval(queue, 1000);
    queue();
  }

  /* ================= 2. build your box ================= */
  /* One line under each category heading. Keyed by the heading text. */
  var STRIPS = {
    'cold-pressed juices': 'Pressed to order · never pasteurised · 3 days in the fridge',
    'handmade nut milks': 'Activated almonds, made fresh in our kitchen',
    'soups & broths': 'Slow simmered, for when cold juice is the last thing you want',
    'shots': 'Ginger, turmeric and live cultures in one small bottle',
    'bundles': 'Our most ordered line ups, six bottles in every box'
  };
  function addStrips(){
    [].slice.call(document.querySelectorAll('.babh-h')).forEach(function(h){
      if (h.querySelector('.mob23-strip')) return;
      var t = h.querySelector('.babh-h__t');
      var key = t ? t.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      var text = STRIPS[key];
      if (!text) return;
      var p = document.createElement('p');
      p.className = 'mob23-strip';
      p.textContent = text;
      h.classList.add('mob23-has-strip');
      h.appendChild(p);
    });
  }

  var cartTotal = null;
  var totalEls = [];
  function paintTotals(){
    totalEls.forEach(function(el){ el.textContent = cartTotal == null ? '' : money(cartTotal); });
  }
  var refreshT = 0;
  function refreshTotal(delay){
    clearTimeout(refreshT);
    refreshT = setTimeout(function(){
      getCart().then(function(c){ cartTotal = c ? c.total_price : null; paintTotals(); }).catch(function(){});
    }, delay || 0);
  }

  /* Go to the cart's delivery step once the box has been written to the
     basket. The box writes every change to the basket itself; this only
     waits for the write in flight to land, and adds the box's bottles if
     for any reason they are missing. */
  /* BYB-250 (28 Oct): the busy flag only guards a double click. It used to
     stay set after the page left for /cart, so coming Back (the browser
     restores the page as it was) left a Checkout that did nothing when
     pressed. It is now cleared on that return, and one older than 8s is
     ignored whatever happened. */
  function goFromBox(root, btn){
    if (btn.getAttribute('aria-busy') === 'true' && Date.now() - (+btn.getAttribute('data-m23-busy') || 0) < 8000) return;
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('data-m23-busy', String(Date.now()));
    var started = Date.now();
    (function wait(){
      if (/(^|\s)is-syncing(\s|$)/.test(root.className) && Date.now() - started < 6000) { setTimeout(wait, 150); return; }
      setTimeout(function(){
        getCart().then(function(c){
          var hasBox = c && c.items && c.items.some(function(it){ return it.properties && it.properties._pbx; });
          if (hasBox || !c) return c;
          /* Nothing from the box made it into the basket: add it now, as one
             time lines exactly as the box would. */
          var picked = [];
          try {
            for (var k in localStorage) {
              if (k.indexOf('pbx:box:') === 0) {
                var d = JSON.parse(localStorage.getItem(k) || '{}');
                if (d && d.picked && d.picked.length) { picked = d.picked; break; }
              }
            }
          } catch (e) {}
          if (!picked.length) return c;
          var want = {};
          picked.forEach(function(id){ want[id] = (want[id] || 0) + 1; });
          var items = Object.keys(want).map(function(id){ return { id: parseInt(id, 10), quantity: want[id], properties: { '_pbx': 'build-a-box' } }; });
          return fetch(ROOT + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(getCart);
        }).then(function(c){
          if (c && c.item_count > 0) { window.location.href = CART_DELIVERY; return; }
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('data-m23-busy');
        }).catch(function(){ window.location.href = CART_DELIVERY; });
      }, 250);
    })();
  }

  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    [].slice.call(document.querySelectorAll('.mob23-go[aria-busy]')).forEach(function(b){
      b.removeAttribute('aria-busy');
      b.removeAttribute('data-m23-busy');
    });
  });

  function mkGo(label){
    var a = document.createElement('a');
    a.className = 'mob23-go';
    a.href = CART_DELIVERY;
    a.setAttribute('data-mob23-go', '');
    a.innerHTML = '<span>' + label + '</span><span aria-hidden="true">·</span><span data-mob23-total></span>';
    return a;
  }

  function setupBox(root){
    if (root.__mob23) return;
    root.__mob23 = true;
    var dock = root.querySelector('[data-dock]');
    var panel = root.querySelector('[data-panel]');
    var meter = root.querySelector('[data-dockmeter]');
    var openBtn = root.querySelector('[data-sheet-open]');

    if (dock) {
      dock.classList.add('mob23-dock');
      var vb = document.createElement('span');
      vb.className = 'mob23-viewbox';
      vb.textContent = 'View box';
      var txt = dock.querySelector('.pbx__docktext');
      if (txt) txt.appendChild(vb);
      var go = mkGo('Checkout');
      dock.appendChild(go);
      go.addEventListener('click', function(e){ e.preventDefault(); goFromBox(root, go); });
    }
    if (panel) {
      var bar = document.createElement('div');
      bar.className = 'mob23-sheetbar';
      bar.innerHTML = '<span class="mob23-sheetbar__t"><small>Total</small><strong data-mob23-total></strong><span class="mob23-sheetbar__save" data-mob23-save hidden></span></span>';
      var go2 = mkGo('Checkout');
      go2.innerHTML = 'Checkout';
      bar.appendChild(go2);
      panel.appendChild(bar);
      go2.addEventListener('click', function(e){ e.preventDefault(); goFromBox(root, go2); });
    }
    totalEls = [].slice.call(document.querySelectorAll('[data-mob23-total]'));

    function syncReady(){
      var count = 0;
      var dc = root.querySelector('[data-dock-count]');
      if (dc) count = parseInt(dc.textContent, 10) || 0;
      var ready = !!(meter && meter.classList.contains('is-ready')) && count > 0;
      if (dock) dock.classList.toggle('mob23-ready', ready);
      root.classList.toggle('mob23-boxready', ready);
    }
    if (window.MutationObserver) {
      var mo = new MutationObserver(function(){ syncReady(); });
      if (meter) mo.observe(meter, { attributes: true, attributeFilter: ['class'] });
      var dc = root.querySelector('[data-dock-count]');
      if (dc) mo.observe(dc, { childList: true, characterData: true, subtree: true });
      /* the box writes to the basket after every change; re-read the total
         when the write has finished */
      new MutationObserver(function(){
        if (!/(^|\s)is-syncing(\s|$)/.test(root.className)) { refreshTotal(600); loadAlso(root, 650); }
        paintSave(root);
        queue();
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    }
    syncReady();
    refreshTotal(0);
    setupAlso(root);
    root.addEventListener('change', function(){ setTimeout(function(){ paintSave(root); }, 0); });
    paintSave(root);
    if (openBtn) openBtn.addEventListener('click', function(){ refreshTotal(0); });
    html.addEventListener('theme:cartchanged', function(){ refreshTotal(400); });
    /* the close button: a clear 40px circle (inline, as the section styles
       every button in it with an id selector) */
    var closeBtn = root.querySelector('[data-sheet-close]');
    if (closeBtn && phone()) {
      ['width', 'height', 'min-height'].forEach(function(k){ closeBtn.style.setProperty(k, '40px', 'important'); });
      closeBtn.style.setProperty('border-radius', '50%', 'important');
      closeBtn.style.setProperty('background', '#ecebf5', 'important');
    }

    /* category notes */
    addStrips();
    var grid = root.querySelector('.pbx__grid');
    if (grid && window.MutationObserver) {
      var t = 0;
      new MutationObserver(function(){ clearTimeout(t); t = setTimeout(addStrips, 50); }).observe(grid, { childList: true });
    }
  }

  /* ================= BOX-23: the rest of the basket, editable, in the box sheet =================
     Every basket line the box did not put there (no _pbx property) is listed
     under the box with -/+ and a remove x, changed through /cart/change.js by
     line key. After a change the basket event is sent, so the box re-reads
     the basket for its minimum, the drawer and header update, and the
     footer total is repainted from the answer. Prices, discounts and the box
     lines themselves are untouched. */
  var MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var XSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function escA(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sized(u){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
  function renderAlso(root, c){
    var box = root.__m23also;
    if (!box || !c || !c.items) return;
    var lines = c.items.filter(function(it){ return !(it.properties && it.properties._pbx); });
    box.hidden = !lines.length;
    box.querySelector('ul').innerHTML = lines.map(function(it){
      var t = escA(it.product_title || it.title);
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? escA(it.variant_title) : '';
      var price = typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price;
      var k = escA(it.key);
      return '<li class="pbx__line mob23-also__line">' +
        '<span class="mob23-lthumb">' + (it.image ? '<img decoding="async" class="pbx__thumb" src="' + escA(sized(it.image)) + '" alt="" loading="lazy">' : '') +
          '<button type="button" class="mob23-also__x" data-m23-key="' + k + '" data-m23-q="0" aria-label="Remove ' + t + ' from your basket">' + XSVG + '</button></span>' +
        '<span class="pbx__lname">' + t + (v ? '<span class="mob23-also__v">' + v + '</span>' : '') + '</span>' +
        '<span class="pbx__ministep">' +
          '<button type="button" data-m23-key="' + k + '" data-m23-q="' + (it.quantity - 1) + '" aria-label="Remove one ' + t + '">' + MINUS + '</button>' +
          '<span class="pbx__lqty">' + it.quantity + '</span>' +
          '<button type="button" data-m23-key="' + k + '" data-m23-q="' + (it.quantity + 1) + '" aria-label="Add one ' + t + '">' + PLUS + '</button>' +
        '</span>' +
        '<span class="mob23-lprice">' + money(price) + '</span>' +
        '</li>';
    }).join('');
    var n = 0; lines.forEach(function(it){ n += it.quantity; });
    var h = box.querySelector('.mob23-also__h');
    if (h) h.textContent = 'Also in your basket · ' + n + (n === 1 ? ' item' : ' items');
  }
  function loadAlso(root, delay){
    clearTimeout(root.__m23alsoT);
    root.__m23alsoT = setTimeout(function(){
      getCart().then(function(c){ renderAlso(root, c); }).catch(function(){});
    }, delay || 0);
  }
  function setupAlso(root){
    var linesEl = root.querySelector('[data-lines]');
    if (!linesEl || root.__m23also) return;
    var box = document.createElement('div');
    box.className = 'mob23-also';
    box.hidden = true;
    box.innerHTML = '<p class="mob23-also__h">Also in your basket</p><ul class="pbx__lines mob23-also__list"></ul>';
    linesEl.parentNode.insertBefore(box, linesEl.nextSibling);
    root.__m23also = box;
    /* the box's own rows: a heading with the count, the size under the name
       and the line price on the right, redrawn whenever the box redraws */
    var bh = document.createElement('p');
    bh.className = 'mob23-lh';
    bh.hidden = true;
    linesEl.parentNode.insertBefore(bh, linesEl);
    function decorate(){
      var plan = root.querySelector('[data-plan]:checked');
      var pc = plan ? parseFloat(plan.getAttribute('data-discount') || '0') : 0;
      var total = 0;
      [].slice.call(linesEl.querySelectorAll('li.pbx__line')).forEach(function(li){
        var b = li.querySelector('[data-line-minus]');
        var q = li.querySelector('.pbx__lqty');
        if (!b || !q) return;
        var id = b.getAttribute('data-line-minus');
        var qty = parseInt(q.textContent, 10) || 0;
        total += qty;
        var size = root.querySelector('[data-size="' + id + '"]');
        var card = root.querySelector('[data-item][data-vid="' + id + '"]');
        var unit = size ? parseInt(size.getAttribute('data-size-price'), 10) : (card ? parseInt(card.getAttribute('data-price'), 10) : NaN);
        var nm = li.querySelector('.pbx__lname');
        if (nm && size && !nm.querySelector('.mob23-also__v')) {
          var sv = document.createElement('span');
          sv.className = 'mob23-also__v';
          sv.textContent = size.textContent.replace(/\s+/g, ' ').trim();
          nm.appendChild(sv);
        }
        var pr = li.querySelector('.mob23-lprice');
        if (!pr) { pr = document.createElement('span'); pr.className = 'mob23-lprice'; li.appendChild(pr); }
        var txt = isNaN(unit) ? '' : money(Math.round(unit * qty * (1 - pc / 100)));
        if (pr.textContent !== txt) pr.textContent = txt;
      });
      bh.hidden = !total || linesEl.hidden;
      var ht = 'Your box · ' + total + (total === 1 ? ' bottle' : ' bottles');
      if (bh.textContent !== ht) bh.textContent = ht;
    }
    if (window.MutationObserver) new MutationObserver(decorate).observe(linesEl, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    root.addEventListener('change', function(){ setTimeout(decorate, 0); });
    decorate();
    box.addEventListener('click', function(e){
      var b = e.target && e.target.closest ? e.target.closest('[data-m23-key]') : null;
      if (!b) return;
      e.preventDefault();
      var li = b.closest('li');
      if (li) li.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-m23-key'), quantity: Math.max(0, parseInt(b.getAttribute('data-m23-q'), 10) || 0) })
      }).then(function(r){ return r.json(); }).then(function(c){
        renderAlso(root, c);
        if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; paintTotals(); }
        try { html.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, detail: { openDrawer: false } })); } catch (err) {}
      }).catch(function(){ if (li) li.removeAttribute('aria-busy'); loadAlso(root, 0); });
    });
    html.addEventListener('theme:cartchanged', function(){ loadAlso(root, 500); });
    loadAlso(root, 0);
  }
  /* the box saving, as a small line under the total, only with a frequency */
  function paintSave(root){
    var el = root.querySelector('[data-mob23-save]');
    if (!el) return;
    var plan = root.querySelector('[data-plan]:checked');
    var pc = plan ? parseFloat(plan.getAttribute('data-discount') || '0') : 0;
    var dc = root.querySelector('[data-dock-count]');
    var n = dc ? (parseInt(dc.textContent, 10) || 0) : 0;
    el.hidden = !(pc > 0 && n > 0);
    el.textContent = pc > 0 ? 'Includes ' + pc + '% off your box juices' : '';
  }

  /* ================= BOX-23: messages =================
     Success lines are hidden (CSS above); the under-minimum line reads "Add
     £X more to reach our £35 minimum" in the box, its bottom bar, the cart
     drawer and /cart. The £35 is the theme's own minimum (3500 in the box
     and the cart). Runs before paint, as the text is redrawn. */
  var MIN_TXT = '£35';
  function fixMsgs(){
    var els = document.querySelectorAll('.pcart-min__msg, p.pcart-min, [data-hint], [data-dock-hint]');
    for (var i = 0; i < els.length; i++){
      var el = els[i], t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var m = t.match(/^(?:Spend |Add )?(£[\d,]+(?:\.\d\d)?) (?:more|of anything) to check out\.?(?: Minimum order is £[\d,.]+\.?)?$/i);
      if (m) {
        var n = 'Add ' + m[1] + ' more to reach our ' + MIN_TXT + ' minimum';
        if (t !== n) el.textContent = n;
      }
      var win = /great stuff|good to check out|you've picked some of our favourites/i.test(t);
      if (win !== el.classList.contains('mob23-win')) el.classList.toggle('mob23-win', win);
    }
  }
  /* ================= GOAL-23: labels on the goal picker match card =================
     The match card's length buttons get the same Most popular / Best results
     labels (and so the same shine) as the product's own card on the page:
     read from that product's collection card (.cg-vcard-tag, matched by
     length). If the product has no card on the page: Most popular on 3 days,
     Best results on 7 days. Re-applied whenever the card redraws. */
  function lenKey(num, unit){ return String(num || '').trim() + (String(unit || '').trim().charAt(0) || '').toLowerCase(); }
  function goalLabels(){
    var res = document.querySelectorAll('.pg-result');
    for (var i = 0; i < res.length; i++){
      var r = res[i];
      var lens = r.querySelectorAll('.pg-lengths > .pg-len');
      if (!lens.length) continue;
      var a = r.querySelector('a[href*="/products/"]');
      var m = a ? (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/) : null;
      var map = null;
      if (m) {
        var links = document.querySelectorAll('a[href*="/products/' + m[1] + '"]');
        for (var j = 0; j < links.length && !map; j++){
          if (r.contains(links[j])) continue;
          var c = links[j].parentElement;
          while (c && c !== document.body && !c.querySelector('.cg-vcards')) c = c.parentElement;
          var row = c && c !== document.body ? c.querySelector('.cg-vcards') : null;
          if (!row) continue;
          map = {};
          [].slice.call(row.querySelectorAll('.cg-vcard')).forEach(function(v){
            var tg = v.querySelector('.cg-vcard-tag');
            var nu = v.querySelector('.cg-vcard-num'), un = v.querySelector('.cg-vcard-unit');
            if (tg && nu) map[lenKey(nu.textContent, un ? un.textContent : '')] = tg.textContent.replace(/\s+/g, ' ').trim();
          });
        }
      }
      if (!map) map = { '3d': 'Most popular', '7d': 'Best results' };
      for (var k = 0; k < lens.length; k++){
        var b = lens[k];
        var nn = b.querySelector('.pg-len-num'), uu = b.querySelector('.pg-len-unit');
        var want = nn ? (map[lenKey(nn.textContent, uu ? uu.textContent : '')] || '') : '';
        var tag = b.querySelector('.pg-len-tag');
        if (!want) { if (tag) tag.parentNode.removeChild(tag); continue; }
        if (tag && tag.textContent === want) continue;
        if (!tag) { tag = document.createElement('span'); tag.className = 'pg-len-tag'; b.insertBefore(tag, b.firstChild); }
        tag.textContent = want;
      }
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(function(){
      fixMsgs(); goalLabels();
      if (document.querySelector('.pr-pdp__bottles')) { clearTimeout(shotT); shotT = setTimeout(setupPdpShots, 250); }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  /* ================= 4. /cart page ================= */
  function setupCartPage(){
    if (!document.body || !/(^|\s)template-cart(\s|$)/.test(document.body.className)) return;
    var sec = document.querySelector('section.pcart-section[data-pcart]') || document.querySelector('main .pcart-section');
    if (!sec) return;
    var real = sec.querySelector('.pcart-checkout, [name="checkout"]');
    if (!real) return;
    var bar = document.createElement('div');
    bar.className = 'mob23-cartbar';
    bar.innerHTML = '<span class="mob23-sheetbar__t"><small>Total</small><strong data-mob23-cart-total></strong></span>' +
      '<button type="button" class="mob23-go">Checkout</button>';
    document.body.appendChild(bar);
    document.body.classList.add('mob23-has-cartbar');
    var out = bar.querySelector('[data-mob23-cart-total]');
    function paint(){
      var t = sec.querySelector('.pcart-total');
      var m = t ? (t.textContent.match(/£\s?[\d,]+\.\d\d/g) || []) : [];
      out.textContent = m.length ? m[m.length - 1].replace(/\s/g, '') : '';
      var now = sec.querySelector('.pcart-checkout, [name="checkout"]');
      if (now && now !== real && io) { io.disconnect(); realVisible = false; io.observe(now); }
      real = now;
      bar.hidden = !real;
      document.body.classList.toggle('mob23-has-cartbar', !!real);
    }
    var realVisible = false, typing = false, io = null;
    function place(){ bar.classList.toggle('is-away', realVisible || typing); }
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function(en){ realVisible = en[en.length - 1].isIntersecting; place(); });
      io.observe(real);
    }
    paint();
    if (window.MutationObserver) new MutationObserver(paint).observe(sec, { childList: true, subtree: true, characterData: true });
    /* pressing it presses the real Checkout button, so the delivery checks
       (postcode, start date, confirm) run exactly as they do there */
    bar.querySelector('button').addEventListener('click', function(){
      var b = sec.querySelector('.pcart-checkout, [name="checkout"]');
      if (b) b.click();
    });
    /* out of the way while the real button is on screen (above) or while
       typing */
    document.addEventListener('focusin', function(e){
      var t = e.target; typing = !!(t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) && t.type !== 'checkbox' && t.type !== 'radio'); place();
    });
    document.addEventListener('focusout', function(){ typing = false; setTimeout(place, 50); });
    /* arriving from a Checkout button elsewhere: open on the delivery step */
    if (location.hash === '#delivery') {
      setTimeout(function(){
        var d = sec.querySelector('[data-pdc]');
        if (d) d.scrollIntoView({ block: 'start', behavior: 'auto' });
        if (d) window.scrollBy(0, -80);
      }, 500);
    }
  }

  /* ================= 6. "View ingredients": the day, with times =================
     The collection and homepage cards open a list of bottles and their
     ingredients. It now reads like the product page: the bottles in the
     order they are drunk, each with its time, shots marked. The order and
     the times come from snippets/cleanse-schedule (custom.juice_order,
     custom.cleanse_times, the Celery and Weight Loss rules), the same source
     as the product page's Bottle by bottle list, served for each product by
     templates/product.mob23-schedule.liquid. If that cannot be read, the
     list stays exactly as it was. */
  var schedCache = {};
  function schedFor(handle){
    if (!schedCache[handle]) {
      schedCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=mob23-schedule', { credentials: 'same-origin' })
        .then(function(r){ if (!r.ok) throw new Error('sched'); return r.text(); })
        .then(function(t){ return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); });
      schedCache[handle].catch(function(){ delete schedCache[handle]; });
    }
    return schedCache[handle];
  }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  /* ================= DOSE-24: the daily dose line =================
     "Your daily dose: 5 × 500ml juices, 1 × 500ml nut mylk and 2 ×
     30ml booster shots". Counted by type from the plan's schedule (the
     bottles of one day). The sizes come from the product's
     custom.presscription_content ("5x 500ml COLD PRESSED JUICES" ...) when its
     counts agree with the schedule; otherwise 30ml for shots and the plan's
     bottle size (500ml, 250ml on the 5:2 plans) for the rest. Celery:
     "1 × 500ml celery juice each morning"; 5:2: "... per cleanse day". No
     schedule, no line. */
  var DOSE_ORDER = ['juice', 'soup', 'broth', 'mylk', 'shot'];
  var DOSE_NAME = { juice: ['juice', 'juices'], soup: ['soup', 'soups'], broth: ['broth', 'broths'], mylk: ['nut mylk', 'nut mylk'], shot: ['booster shot', 'booster shots'] };
  function doseCat(s){
    s = String(s || '').toLowerCase();
    if (/shot/.test(s)) return 'shot';
    if (/mylk|milk/.test(s)) return 'mylk';
    if (/broth/.test(s)) return 'broth';
    if (/soup/.test(s)) return 'soup';
    return 'juice';
  }
  function doseLine(d){
    if (!d || !d.rows || !d.rows.length) return '';
    var base = d.ml || '500ml';
    var lines = String(d.pc || '').split(/<\/p>|<br\s*\/?>/i).map(function(l){
      var x = document.createElement('div'); x.innerHTML = l; return x.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
    if (d.celery) {
      var cm = lines.join(' ').match(/(\d+)\s*ml/i);
      return 'Your daily dose: 1 × ' + (cm ? cm[1] + 'ml' : base) + ' celery juice each morning';
    }
    /* PDP25C: the teas are a count from the schedule (d.teas), never rows */
    var cnt = {}, size = {}, teas = +d.teas || 0;
    d.rows.forEach(function(r){ if (r.tea) return; var c = r.shot ? 'shot' : doseCat(r.ty); cnt[c] = (cnt[c] || 0) + 1; });
    /* the metafield, used for sizes only when it says the same as the schedule */
    var pc = {}, psize = {}, ok = lines.length > 0;
    lines.forEach(function(l){
      var m = l.match(/^(?:(\d+)\s*x|x\s*(\d+))\s*(\d+\s*ml)?\s*(.+)$/i);
      if (!m) { ok = false; return; }
      var c = doseCat(m[4]);
      pc[c] = (pc[c] || 0) + parseInt(m[1] || m[2], 10);
      if (m[3]) psize[c] = m[3].replace(/\s+/g, '').toLowerCase();
    });
    if (ok) DOSE_ORDER.forEach(function(c){ if ((pc[c] || 0) !== (cnt[c] || 0)) ok = false; });
    var parts = [];
    DOSE_ORDER.forEach(function(c){
      var n = cnt[c];
      if (!n) return;
      var sz = (ok && psize[c]) || (c === 'shot' ? '30ml' : base);
      parts.push(n + ' × ' + sz + ' ' + DOSE_NAME[c][n === 1 ? 0 : 1]);
    });
    if (!parts.length) return '';
    /* TEAS-24: the functional teas (snippets/cleanse-teas) close the list */
    if (teas) parts.push(teas === 1 ? 'a functional tea' : teas + ' functional teas');
    var txt = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
    var per = /(^|-)5-2(-|$)/.test(d.handle || '') ? ' per cleanse day' : '';
    return 'Your daily dose: ' + txt + per;
  }
  var CUP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9z"></path><path d="M16 11h1.5a2.5 2.5 0 0 1 0 5H16"></path><path d="M8 3c0 1.5 1.5 1.5 1.5 3M12 3c0 1.5 1.5 1.5 1.5 3"></path></svg>';
  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>';
  /* SCROLL-24: the dose line, the order line and the list go in one
     scrolling box under the popup's header; the page is locked while the
     popup is open (follows the dialog's open attribute, so every way of
     closing it unlocks) */
  function ingBody(dlg){
    var list = dlg && dlg.querySelector('[data-cg-ing-list]');
    if (!list) return null;
    var body = dlg.querySelector('.mob23-tt-body');
    if (!body) {
      body = document.createElement('div');
      body.className = 'mob23-tt-body';
      list.parentNode.insertBefore(body, list);
    }
    [].slice.call(dlg.querySelectorAll('.mob23-tt-note, .mob23-tt-order')).forEach(function(n){ if (n.parentNode !== body) body.appendChild(n); });
    if (list.parentNode !== body) body.appendChild(list);
    if (!dlg.__m23lock && window.MutationObserver) {
      dlg.__m23lock = true;
      new MutationObserver(function(){
        var open = dlg.hasAttribute('open');
        html.classList.toggle('mob23-lock', open);
        if (open) body.scrollTop = 0;
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    html.classList.toggle('mob23-lock', dlg.hasAttribute('open'));
    return body;
  }
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[data-cg-ing-open]') : null;
    if (!btn) return;
    setTimeout(function(){
      var b = ingBody(document.querySelector('dialog.cg-ing[open]') || document.querySelector('[data-cg-ing]'));
      if (b) b.scrollTop = 0;
    }, 0);
    var card = btn.parentElement;
    while (card && !(card.querySelector && card.querySelector('a[href*="/products/"]'))) card = card.parentElement;
    var link = card ? card.querySelector('a[href*="/products/"]') : null;
    var m = link ? (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/) : null;
    if (!m) return;
    var title = (btn.getAttribute('data-ing-title') || '').trim();
    schedFor(m[1]).then(function(d){
      if (!d || !d.rows || !d.rows.length) return;
      var dlg = document.querySelector('dialog.cg-ing[open]') || document.querySelector('[data-cg-ing]');
      if (!dlg) return;
      var t = dlg.querySelector('[data-cg-ing-title]');
      if (t && title && t.textContent.trim() !== title) return;   /* another card was opened since */
      var list = dlg.querySelector('[data-cg-ing-list]');
      if (!list) return;
      var bn = 0;
      list.innerHTML = d.rows.map(function(r, i){
        /* TEAS-24: a functional tea is not a numbered bottle */
        if (r.tea) return '<li class="cg-ing__row mob23-tt-row mob23-tt-tea">' +
          '<span class="cg-ing__thumb" aria-hidden="true">' + CUP + '</span>' +
          '<span><span class="mob23-tt-top"><p class="cg-ing__name">' + esc(r.t) + '<span class="mob23-tt-teab">Tea</span></p>' +
          (r.time ? '<span class="mob23-tt-when">' + CLOCK + esc(r.time) + '</span>' : '') + '</span>' +
          (r.i ? '<p class="cg-ing__items">' + esc(r.i) + '</p>' : '') + '</span></li>';
        bn++;
        var num = d.celery ? 'Days 1&ndash;7.' : bn + '.';
        return '<li class="cg-ing__row mob23-tt-row">' +
          '<span class="cg-ing__thumb">' + (r.m ? '<img src="' + esc(r.m) + '" alt="" loading="eager">' : '') + '</span>' +
          '<span><span class="mob23-tt-top"><p class="cg-ing__name"><span class="mob23-tt-n">' + num + '</span>' + esc(r.shot ? String(r.t).replace(/\s+shot\s*$/i, '') : r.t) +
          (r.shot ? '<span class="mob23-tt-shot">Shot</span>' : '') + (d.ml ? '<span class="mob23-tt-ml">' + esc(d.ml) + '</span>' : '') + '</p>' +
          (r.time ? '<span class="mob23-tt-when">' + CLOCK + esc(r.time) + '</span>' : '') + '</span>' +
          (r.i ? '<p class="cg-ing__items">' + esc(r.i) + '</p>' : '') + '</span></li>';
      }).join('');
      var note = dlg.querySelector('.mob23-tt-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'mob23-tt-note';
        list.parentNode.insertBefore(note, list);
      }
      /* DOSE-24: the daily dose, then "Drink them in this order:" (the dose
         carries the bottle size, so the SIZE-23 note is folded into it) */
      var dose = doseLine(d);
      var order = dlg.querySelector('.mob23-tt-order');
      if (!order) {
        order = document.createElement('p');
        order.className = 'mob23-tt-order';
        order.textContent = 'Drink them in this order:';
        list.parentNode.insertBefore(order, list);
      }
      order.hidden = !dose || !!d.celery;
      /* SIZE-23 (fallback): plans with smaller bottles (the 5:2 plans, 250ml) say so */
      note.textContent = dose || (d.ml ? 'All bottles in this plan are ' + d.ml + '. Your day, in the order you drink them.' :
        (d.celery ? 'One bottle each morning.' : 'Your day, in the order you drink them.'));
      note.classList.toggle('is-dose', !!dose);
      note.classList.toggle('is-ml', !dose && !!d.ml);
      ingBody(dlg);
    }).catch(function(){});
  });

  /* ================= 7. product page description: two lines on phones ================= */
  function setupPdpDesc(){
    if (!phone()) return;
    [].slice.call(document.querySelectorAll('[id^="pr-pdp-"] .pr-pdp__desc')).forEach(function(d){
      if (d.__mob23 || d.hasAttribute('data-pdp25')) return;
      d.__mob23 = true;
      /* CLAMP-24: only plain description text is ever clamped. Some
         descriptions (legacy markup, e.g. the 5:2 plans' .product__hero__copy)
         wrap the buy form, options, buttons or accordions; the clamp then
         takes just the leading text before the first such element, and is
         skipped when there is no text ahead of it. */
      var CTRL = 'form, input, button, select, textarea, [type="submit"], label, details, summary, iframe, product-form, variant-radios, variant-selects, .product__hero__copy, .product-form, [data-product-form], [class*="pr-pdp__"]';
      var lead = [];
      for (var c = d.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 1 && (c.matches(CTRL) || c.querySelector(CTRL))) break;
        lead.push(c);
      }
      var leadText = lead.map(function(n){ return n.textContent || ''; }).join('').replace(/\s+/g, '');
      if (!leadText) return;
      var inner = document.createElement('div');
      inner.className = 'mob23-desc-in';
      d.insertBefore(inner, lead[0]);
      lead.forEach(function(n){ inner.appendChild(n); });
      var probe = inner.querySelector('p') || inner;
      var lh = parseFloat(getComputedStyle(probe).lineHeight) || 22;
      d.style.setProperty('--mob23-lh', lh + 'px');
      d.classList.add('mob23-clamp');
      if (inner.scrollHeight <= lh * 2 + 4) { d.classList.remove('mob23-clamp'); return; }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mob23-more';
      b.textContent = 'Read more';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function(){
        var open = d.classList.toggle('is-open');
        b.textContent = open ? 'Read less' : 'Read more';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      d.insertBefore(b, inner.nextSibling);
    });
  }

  /* ================= 8. goal picker match card: price, Add to cart and
     View full details on one row (the price row is moved, not copied, so
     the picker still updates it) ================= */
  function setupPg(){
    [].slice.call(document.querySelectorAll('.pg-result')).forEach(function(r){
      var pr = r.querySelector('.pg-price-row'), ac = r.querySelector('.pg-actions');
      if (pr && ac && pr.parentNode !== ac) ac.insertBefore(pr, ac.firstChild);
    });
  }

  /* ================= SIZE-23: product page of a plan with smaller bottles ================= */
  var PDP_ML = window.M23_ML || '';
  function setupPdpMl(){
    if (!PDP_ML) return;
    [].slice.call(document.querySelectorAll('.pr-pdp__acc-meta, .itb-sub')).forEach(function(el){
      if (el.nextElementSibling && el.nextElementSibling.classList.contains('mob23-ml-note')) return;
      var n = document.createElement('span');
      n.className = 'mob23-ml-note';
      n.textContent = 'All bottles in this plan are ' + PDP_ML + '.';
      el.parentNode.insertBefore(n, el.nextSibling);
    });
  }

  /* ================= SHOTPDP-23: SHOT badges in the product page's Bottle by bottle list =================
     Same source and rule as the View ingredients popup: the product's
     schedule (templates/product.mob23-schedule.liquid), where a bottle is a
     shot when its product type contains "shot". Matched to the list by the
     bottle's link; a bottle at a shot time (12:30pm, 4:30pm) also counts, so
     a list redrawn for another cleanse option is still marked. */
  var shotT = 0;
  function setupPdpShots(){
    var list = document.querySelector('.pr-pdp__bottles');
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!list || !m) return;
    schedFor(m[1]).catch(function(){ return null; }).then(function(d){
      var shots = {};
      if (d && d.rows) d.rows.forEach(function(r){ if (r.shot && r.u) shots[String(r.u).split('?')[0]] = true; });
      [].slice.call(document.querySelectorAll('.pr-pdp__bottles .pr-pdp__bottle-name')).forEach(function(n){
        var a = n.querySelector('a[href*="/products/"]');
        if (!a || n.querySelector('.mob23-tt-shot')) return;
        var href = (a.getAttribute('href') || '').split('?')[0];
        var row = n.closest('.pr-pdp__bottle-row');
        var w = row ? row.querySelector('.pr-pdp__when') : null;
        var tm = w ? w.textContent.replace(/\s+/g, '').toLowerCase() : '';
        if (!shots[href] && tm !== '12:30pm' && tm !== '4:30pm') return;
        /* the badge says it: "The Probiotic 1 Kefir Shot" reads "The Probiotic 1 Kefir" + SHOT */
        if (/\s+shot\s*$/i.test(a.textContent)) a.textContent = a.textContent.replace(/\s+shot\s*$/i, '');
        var b = document.createElement('span');
        b.className = 'mob23-tt-shot';
        b.textContent = 'Shot';
        a.parentNode.insertBefore(b, a.nextSibling);
      });
      paintPdpDose(d);
    }).catch(function(){});
  }
  /* DOSE-24: the same daily dose line at the top of the Bottle by bottle
     list (under its heading), unless the list already has one */
  function paintPdpDose(d){
    var txt = doseLine(d);
    if (!txt) return;
    [].slice.call(document.querySelectorAll('.pr-pdp__bottles')).forEach(function(l){
      var box = l.parentNode;
      if (!box || box.querySelector('.mob23-dose') || /daily dose/i.test(box.textContent)) return;
      var p = document.createElement('p');
      p.className = 'mob23-dose';
      p.textContent = txt;
      var head = box.querySelector('.pr-pdp__acc-meta');
      var after = head && head.parentNode === box ? head : null;
      while (after && after.nextElementSibling && after.nextElementSibling.classList.contains('mob23-ml-note')) after = after.nextElementSibling;
      box.insertBefore(p, after ? after.nextSibling : l);
      [].slice.call(box.querySelectorAll('.mob23-ml-note')).forEach(function(n){ n.classList.add('is-dosed'); });
    });
  }

  function init(){
    fixMsgs();
    setupPdpShots();
    goalLabels();
    setupPdpMl();
    startGuard();
    boxRoots().forEach(setupBox);
    setupCartPage();
    setupPdpDesc();
    setupPg();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();